module.exports = __webpack_public_path__ + "media/redviolin.c0224552.mp3";